import {PageDataHolderFetchedWidget} from "../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {computed} from "vue";
import Accommodation from "../../lib/models/Accommodation";
import {useTyrionMasterPage} from "../master_page";
import {useState} from "#app";

export function useWidget(widget: PageDataHolderFetchedWidget) {

    const content = computed<Accommodation>(() =>  (new Accommodation()).fromObject(widget.content) as Accommodation);

    return {accommodation: content.value}
}
